import { useRef, useState } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import { FormHelperText, Stack } from "@mui/material";
import { LoginOutlined } from "@mui/icons-material";
import { LoadingButton } from "@mui/lab";

import ReCAPTCHA from "react-google-recaptcha";

import { useForm } from "react-hook-form";
import nameof from "ts-nameof.macro";

import { ErrorMessages, Rules } from "../../../common/validationRules";
import TextFieldExtended from "../../../common/components/mui-extended/TextFieldExtended";
import PasswordLoginDto from "../../../interfaces/PasswordLoginDto";
import authenticationService from "../../../services/authenticationService";
import { AdminRoutesConfig } from "../../RoutesConfig";
import useUserContext from "../../../hooks/useUserContext";
import CardBoxExtended from "../../../common/components/mui-extended/CardBoxExtended";
import { useAxiosLoader } from "../../../common/hooks/useAxiosLoader";

export default function AdminLogin() {
  const SITE_KEY: string = process.env.REACT_APP_STIE_KEY as string;
  const recaptchaRef = useRef<ReCAPTCHA>(null);

  const defaultModel: PasswordLoginDto = {};

  const { isAuthenticated } = useUserContext();
  const navigate = useNavigate();
  const loading = useAxiosLoader(false);
  const [showCaptchaError, setShowCaptchaError] = useState(false);

  const form = useForm<PasswordLoginDto>({
    mode: "all",
    defaultValues: defaultModel,
  });

  const login = async (username: string, password: string) => {
    await authenticationService
      .loginAdmin(username, password)
      .then(({ data: model }) => {
        authenticationService.initLocalStorage(model);
      })
      .then(() => navigate(AdminRoutesConfig.Home.Path, { replace: true }));
  };

  const onSubmit = async (model: PasswordLoginDto) => {
    const recaptchaValue = recaptchaRef?.current?.getValue();
    if (!!recaptchaValue) {
      setShowCaptchaError(false);
      await login(model.username as string, model.password as string);
    } else {
      setShowCaptchaError(true);
    }
  };

  return (
    <>
      {isAuthenticated ? (
        <Navigate to={AdminRoutesConfig.Home.Path} />
      ) : (
        <CardBoxExtended icon={<LoginOutlined color="secondary" />} title="Вход за администратори" titleColor="text">
          <form onSubmit={form.handleSubmit(onSubmit)}>
            <Stack spacing={3} padding={6} alignItems="center" justifyContent="start">
              <TextFieldExtended
                label="Потребител"
                name={nameof(defaultModel.username)}
                form={form}
                rules={Rules.Required}
                sx={{ width: "50%" }}
              />
              <TextFieldExtended
                label="Парола"
                name={nameof(defaultModel.password)}
                type="password"
                form={form}
                rules={Rules.Required}
                sx={{ width: "50%" }}
              />
              <Stack>
                <ReCAPTCHA
                  ref={recaptchaRef}
                  sitekey={SITE_KEY}
                  onChange={(token: any) => setShowCaptchaError(false)}
                />
                {showCaptchaError && <FormHelperText error>{ErrorMessages.Required}</FormHelperText>}
              </Stack>
              <LoadingButton
                variant="contained"
                loadingPosition="start"
                loading={loading}
                startIcon={<LoginOutlined />}
                size="large"
                type="submit"
              >
                ВХОД
              </LoadingButton>
            </Stack>
          </form>
        </CardBoxExtended>
      )}
    </>
  );
}
